/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';

import ViewDocumentDrawer from './ViewDocumentDrawer';

interface Props {
  connectedDocument: any[];
  downloadFile: any;
  type: string;
}

const ConnectedDocuments: React.FC<Props> = ({
  connectedDocument,
  downloadFile,
  type,
}) => {
  const [viewDocumentId, setViewDocumentId] = useState<string>('');
  const [openViewDrawer, setOpenViewDrawer] = useState<boolean>(false);

  const handleCloseViewDrawer = () => {
    setOpenViewDrawer(false);
    setViewDocumentId('');
  };

  return (
    <React.Fragment>
      <Accordion
        sx={{
          padding: 0,
        }}
        className="according-class"
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            width="100%"
          >
            <Typography fontSize="14px" fontWeight={600}>
              {`${type} Documents`}
            </Typography>
            <Typography variant="caption">{connectedDocument?.length}</Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          <Stack width="100%" spacing={2} padding="0 10px">
            {connectedDocument?.map((item: any) => (
              <Stack
                key={item?.id}
                width="100%"
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Typography fontWeight={600}>{item?.file_name}</Typography>
                <Stack spacing={1} direction="row" alignItems="center">
                  <IconButton onClick={() => downloadFile(item?.id)}>
                    <FileDownloadOutlinedIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => {
                      setOpenViewDrawer(true);
                      setViewDocumentId(item?.id);
                    }}
                  >
                    <VisibilityOffIcon />
                  </IconButton>
                </Stack>
              </Stack>
            ))}
            {connectedDocument?.length === 0 && (
              <Typography>{`No ${type} document in this contract`}</Typography>
            )}
          </Stack>
        </AccordionDetails>
      </Accordion>
      {openViewDrawer && (
        <ViewDocumentDrawer
          open={openViewDrawer}
          onClose={handleCloseViewDrawer}
          documentId={viewDocumentId}
        />
      )}
    </React.Fragment>
  );
};

export default ConnectedDocuments;
